import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, IconButton, Link } from '@mui/material';

import * as routes from 'router/routes';
import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from 'constants/components';
import { checkIsFullWidthPage } from 'helper/checkIsFullWidthPage';
import PageContainer from 'layouts/PageContainer';
import { Logo, MenuIcon } from 'assets/icons';

import ProfileDropDown from './ProfileDropDown';

const styles = {
  wrapper: ({ palette, zIndex }) => ({
    position: 'fixed',
    zIndex: zIndex.tooltip,
    width: '100%',
    maxWidth: '100vw',
    backgroundColor: palette.colors.statusBlue,
  }),
  container: ({ breakpoints }) => ({
    width: '100%',
    height: HEADER_HEIGHT_MOBILE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlock: 3,
    paddingInline: 2,

    [breakpoints.up('lg')]: {
      height: HEADER_HEIGHT,
      paddingBlock: 4,
    },
  }),
  link: ({ breakpoints }) => ({
    width: 100,
    height: 30,

    [breakpoints.up('lg')]: {
      width: 180,
      height: 60,
    },

    svg: {
      width: '100%',
      height: '100%',
    },
  }),
  iconButton: ({ palette, breakpoints }) => ({
    color: palette.common.white,
    svg: {
      width: 25,
      height: 25,
      [breakpoints.up('lg')]: {
        width: 36,
        height: 36,
      },
    },
  }),
};

const ResponsiveHeader = ({
  isPublicScreen = false,
  action = null,
  toggleIsMobileMenuOpen = null,
  setIsMobileMenuOpen = null,
  shouldRenderMobileMenu = false,
}) => {
  const { pathname } = useLocation();
  const isFullWidthPage = checkIsFullWidthPage(pathname);

  const onLogoClick = () => {
    if (typeof setIsMobileMenuOpen === 'function') {
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <Box component="header" role="banner" sx={styles.wrapper}>
      <PageContainer maxWidth={isFullWidthPage ? false : undefined} sx={styles.container}>
        <Link component={RouterLink} to={routes.home} sx={styles.link} onClick={onLogoClick} aria-label="Homepage">
          <Logo aria-hidden="true" />
        </Link>

        {action}

        {!isPublicScreen &&
          (shouldRenderMobileMenu && typeof toggleIsMobileMenuOpen === 'function' ? (
            <IconButton
              className="remove_for_pdf"
              onClick={toggleIsMobileMenuOpen}
              sx={styles.iconButton}
              aria-label="Open navigation menu"
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <ProfileDropDown />
          ))}
      </PageContainer>
    </Box>
  );
};

ResponsiveHeader.propTypes = {
  isPublicScreen: PropTypes.bool,
  action: PropTypes.node,
  toggleIsMobileMenuOpen: PropTypes.func,
  setIsMobileMenuOpen: PropTypes.func,
  shouldRenderMobileMenu: PropTypes.bool,
};
export default ResponsiveHeader;
